// extracted by mini-css-extract-plugin
module.exports = {"grid":"ColorSelector_grid__3VuGf"};